<div class="flex flex-col">
  <mat-label>
    {{ label | translate }}
    <span *ngIf="required">*</span>
  </mat-label>

  <mat-form-field class="w-full">
    <mat-select
      [multiple]="multiple"
      [value]="value"
      [placeholder]="placeholder | translate"
      (selectionChange)="onSelectChange($event.value)"
      [disabled]="isDisabled">
      <div *ngIf="selectAll && options?.length > 0 && multiple" class="flex flex-row items-center  border-b border-neutral-200">
        <div class="flex flex-row w-full items-center py-2 px-3 gap-1 cursor-pointer hover:bg-neutral-100" (click)="toggleSelectAll()">
          <app-icon [ngStyle]="{cursor:'pointer'}" size="md" [iconName]="isAllSelected ? 'close' : 'check'"></app-icon>
          <span class="ml-1">{{ (isAllSelected ? 'global.deselectAll' : 'global.selectAll') | translate }}</span>
        </div>
      </div>

      <div class="flex flex-row justify-center items-center w-full border-b border-neutral-200">
        <input matInput class="flex w-full p-3 box-border" [placeholder]="'global.search' | translate" #inputElement (keydown)="$event.stopPropagation()" />
        <button type="button" class="p-1 mr-1 rounded-full hover:bg-neutral-100 active:bg-neutral-300" (click)="clearSearchText()">
          <app-icon iconName="x" size="sm" stroke="#202020"></app-icon>
        </button>
      </div>

      <ng-container *ngFor="let option of filteredOptions">
        <mat-option [style.display]="option.filtered ? 'flex' : 'none'" [value]="option.alpha2Code">
          <div class="flex items-center">
            <img [src]="'assets/svg/flags/' + option.alpha2Code.toLowerCase() + '.svg'" width="20" height="14" class="mr-2" />
            {{ option.name | translate }}
          </div>
        </mat-option>
      </ng-container>
    </mat-select>

    <div class="mr-4" matSuffix *ngIf="!multiple &&value">
      <img [src]="'assets/svg/flags/' + value?.toLowerCase() + '.svg'" width="25" height="25" class="align-middle" />
    </div>
  </mat-form-field>
</div>
